import { getLocalBibInfo, getUserBibInfo } from '@chegg-wt/core/utils/localStorage'
import { AdLayoutName, AdReloadType, AdsConfig } from '../types/site'

export const isProUser = () => {
  const currentUser = getUserBibInfo()
  return (currentUser && currentUser.user && currentUser.user.paidMember) || false
}

/**
 * TODO: make `layout` required
 */
// reload ads with page change or layout change (if the layout changes from the user resizing the browser)
export const reloadAds = (
  adZone: string,
  reloadType: AdReloadType = 'pagechange',
  layout?: AdLayoutName
): Promise<any> => {
  if (isProUser()) {
    return Promise.resolve()
  }

  const localBibInfo = getLocalBibInfo()
  const reloadArgs: AdsConfig = {
    type: reloadType,
    pagetype: adZone,
  }

  /* Because getLocalBibInfo can cast an empty object to EasybibClientState */
  if (typeof localBibInfo.pageCount === 'number') {
    reloadArgs.pageCount = localBibInfo.pageCount
  }

  if (typeof localBibInfo.citationCount === 'number') {
    reloadArgs.citationCount = localBibInfo.citationCount
  }

  if (typeof layout !== 'undefined') {
    reloadArgs.layout = layout
  }

  if (window.SBMGlobal) return window.SBMGlobal.run.reload(reloadArgs)
  return new Promise((resolve) => {
    window.sbmCmd = window.sbmCmd || []
    window.sbmCmd.push((SBMGlobalRunClient) => {
      SBMGlobalRunClient.reload(reloadArgs).then(resolve).catch(resolve)
    })
  })
}

// refresh ads *without* page change
export const refreshAds = (label?: string): Promise<any> => {
  if (!window.SBMGlobal || isProUser()) {
    return Promise.resolve()
  }
  const adPromise = window.SBMGlobal.run.refresh(label)
  // The adPromise can be null in some situations.
  return adPromise || Promise.resolve()
}

export default reloadAds
